module.exports = __webpack_public_path__ + "static/media/mw.e9db1682.jpeg";